import * as Tabs from '@radix-ui/react-tabs';
import styles from './SelectMedia.module.css';
import { SelectMediaCode, SelectMediaCodeProps } from './SelectMediaCode';
import { SelectMediaEmoji, SelectMediaEmojiProps } from './SelectMediaEmoji';
import { SelectMediaIcon, SelectMediaIconProps } from './SelectMediaIcon';
import { SelectMediaIllustration, SelectMediaIllustrationProps } from './SelectMediaIllustration';
import { SelectMediaLink, SelectMediaLinkProps } from './SelectMediaLink';
import { SelectMediaUpload, SelectMediaUploadProps } from './SelectMediaUpload';

interface SelectMediaProps {
  tabs: {
    icon?: SelectMediaIconProps
    emoji?: SelectMediaEmojiProps
    link?: SelectMediaLinkProps
    code?: SelectMediaCodeProps
    upload?: SelectMediaUploadProps
    resources?: SelectMediaIllustrationProps
  }
}

export function SelectMedia(props: SelectMediaProps) {
  const { tabs } = props;

  const tabsList = Object.keys(tabs) as Array<keyof SelectMediaProps['tabs']>;

  const renderTabContent = (tab: typeof tabsList[number]) => {
    switch (tab) {
      case 'icon':
        return <SelectMediaIcon {...tabs[tab]!} />;
      case 'emoji':
        return <SelectMediaEmoji {...tabs[tab]!} />;
      case 'link':
        return <SelectMediaLink {...tabs[tab]!} />;
      case 'code':
        return <SelectMediaCode {...tabs[tab]!} />;
      case 'upload':
        return <SelectMediaUpload {...tabs[tab]!} />;
      case 'resources':
        return <SelectMediaIllustration {...tabs[tab]!} />;
      default:
        return null;
    }
  };

  return (
    <Tabs.Root defaultValue={tabsList[0]} className={styles.tabRoot}>
      <Tabs.List className={styles.tabList}>
        {tabsList.map((tab) => (
          <Tabs.Trigger key={tab} value={tab} className={styles.tabTrigger}>
            <span>{tab}</span>
          </Tabs.Trigger>
        ))}
      </Tabs.List>
      {tabsList.map((tab) => (
        <Tabs.Content key={tab} value={tab}>
          {renderTabContent(tab)}
        </Tabs.Content>
      ))}
    </Tabs.Root>
  );
}
